import { WidgetUnit } from 'types';
import { DisplayedUnitAttributes } from '../types';

export function getResultProp(
  resultId: string,
  units: Record<string, WidgetUnit>,
  unitAttributes: DisplayedUnitAttributes,
): object {
  return {
    ...units[resultId]?.resultProp,
    usedAttrs: unitAttributes[resultId] ?? [],
  };
}

export function loadTrackingIframe(url: string, root?: HTMLElement) {
  const container = root ?? document.body;

  if (container.querySelector(`iframe[src='${url}']`)) {
    return;
  }

  const frame = document.createElement('iframe');
  frame.style.position = 'absolute';
  frame.style.height = '0px';
  frame.style.width = '0px';
  frame.style.border = '0px';
  frame.src = url;

  container?.appendChild(frame);
}

export function loadTrackingPixel(url?: string, root?: HTMLElement) {
  const container = root ?? document.body;

  if (!url || container.querySelector(`img[src='${url}']`)) {
    return;
  }

  const image = document.createElement('img');

  image.src = url;
  image.height = 1;
  image.width = 1;
  image.style.position = 'absolute';

  container.appendChild(image);
}
